import { render, staticRenderFns } from "./ApprovedReservationExtensions.vue?vue&type=template&id=7250ddb4&scoped=true&"
import script from "./ApprovedReservationExtensions.vue?vue&type=script&lang=js&"
export * from "./ApprovedReservationExtensions.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedReservationExtensions.vue?vue&type=style&index=0&id=7250ddb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7250ddb4",
  null
  
)

export default component.exports